import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { renderLazyTileList } from './addWidgetHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const AddWidgetAccordion = ({
  type,
  collection,
  hideTooltips,
  className = '',
  onDragStart,
  onDragEnd,
  sidebarIframeBody,
  searchQuery,
  open,
  onOpenChange,
  shouldRenderTourStep,
  upgradableModules = [],
  title,
  disabled
}) => {
  const numberModules = collection.length + upgradableModules.length;
  return /*#__PURE__*/_jsx(AccordionItem
  // Force remount on non-empty search query to "re-evalulate" defaultOpen
  , {
    title: title || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `addModule.${type}WithCount`,
      options: {
        numberModules
      }
    }),
    open: open,
    onOpenChange: onOpenChange,
    disabled: disabled,
    size: "small",
    titleTagName: "h5",
    removeContentPadding: true,
    Content: numberModules ? renderLazyTileList({
      hideTooltips,
      collection,
      className,
      onDragStart,
      onDragEnd,
      type,
      sidebarIframeBody,
      shouldRenderTourStep,
      upgradableModules
    }) : undefined,
    "data-test-id": `add-module-group-${type}`,
    animate: false
  }, `add-widget-group-${!!searchQuery}`);
};
AddWidgetAccordion.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  collection: PropTypes.array.isRequired,
  hideTooltips: PropTypes.bool,
  searchQuery: PropTypes.string,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  sidebarIframeBody: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  shouldRenderTourStep: PropTypes.bool,
  upgradableModules: PropTypes.array,
  title: PropTypes.node,
  disabled: PropTypes.bool
};
export default AddWidgetAccordion;